import React, { PropsWithChildren } from 'react';
import { IExplainerFocusPanelProps } from './explainer-focus-panel.models';
import { Button, PanelHeader } from '@keplerco/core';
import styles from './explainer-focus-panel.module.css';

export function ExplainerFocusPanelLayout(props: PropsWithChildren<IExplainerFocusPanelProps>): JSX.Element {
  return (
    <div className="panelContent">
      <PanelHeader subtitle={props.subtitle} supertitle={props.supertitle} title={props.title} divider />

      <div className={styles.textWrap}>{props.children}</div>

      <footer className="panelFooter" style={{ justifyContent: 'flex-end' }}>
        <Button type="button" filled arrow={false} onClick={props.onClose}>
          Close
        </Button>
      </footer>
    </div>
  );
}
